import Head from "next/head";
import React from "react";
import AdQuestions from "../components/advertise/AdQuestions";
import Appointement from "../components/advertise/Appointement";
import BenefitsBox from "../components/advertise/BenefitsBox";
import ContactUs from "../components/homepage/ContactUs";
import Footer from "../components/homepage/Footer";
import Header from "../components/homepage/Header";
import SectionBg from "../public/images/bg-center.png";

const Advertise = () => {
  return (
    <div id="advertise-page">
      <Header />
      <Head>
        <title>Advertise</title>
        <meta name="description" content="" />
      </Head>
      <div
        className="absolute w-full h-[830px] top-0 -z-10 "
        style={{
          backgroundColor: "#fff",
          backgroundImage: `url("${SectionBg.src}")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "830",
        }}
      >
        <div className="relative boxed-container">
          <div className="mt-48 text-center">
            <div className="flex flex-col gap-1 text-6xl font-extrabold">
              <span>Get your message</span>
              <span>out there.</span>
            </div>
            <div className="gradient-header">Advertise with EasyDuct.</div>
            <div className="w-[80%] mt-8 font-semibold mb-28 m-auto leading-relaxed">
              Advertising with EasyDuct is the most effective method for
              reaching mechanical contractors in your target locations. By
              utilizing EasyDuct, your advertising budget will stretch further
              than with any other platform. {"Let's"} partner up to attract more
              valuable customers and showcase the brilliance of your business.
            </div>

            <BenefitsBox />
          </div>
          <Appointement />
          <AdQuestions />
          <ContactUs />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Advertise;
Advertise.publicPage = true;
